import { TypographyStylesProvider, Code, Image } from "@mantine/core";
import React from "react";
import DocsButton from "../articlesHelpers/DocsButton"; // Import the new component
import { IconApps } from "@tabler/icons-react";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const NOSTR_WALLET_CONNECT_RECEIVE_CONTENT = (
  <TypographyStylesProvider>
    <p>
      {" "}
      Nostr Wallet Connect provides you with a code (or QR) that you can use to
      make your Rizful node available to other apps and websites.{" "}
    </p>
    <p>
      {" "}
      By default, Rizful Node provides a "Receive Only" connection code, which
      is safe to use with any app. A "Receive Only" connection will only allow{" "}
      <em>inbound</em> payments.{" "}
    </p>

    <p>
      {" "}
      You can get started by clicking the "Apps" button. If you see that the
      button is disabled, like this...{" "}
    </p>

    <DocsButton
      ariaLabel="add apps"
      text="Apps"
      leftSection={<IconApps />}
      disabled={true}
    />
    <p>
      That means you still need to{" "}
      <a href="/docs/getting-inbound#inbound-from-rizful-lsp">
        get inbound capacity
      </a>
      . Once you've done that, you should see that the button is enabled...
    </p>

    <DocsButton
      ariaLabel="add apps"
      text="Apps"
      leftSection={<IconApps />}
      disabled={false}
    />

    <p>
      {" "}
      You will then see that you have already have one default NWC "Receive
      Only" connection.{" "}
    </p>

    <SimpleImage
      src="docs_images/get-connection-code-receive-only.png"
      h={450}
    />

    <p>
      {" "}
      Click{" "}
      <Code style={{ backgroundColor: "green" }}>
        <IconApps
          style={{
            width: "1.2em",
            height: "1.2em",
            position: "relative",
            left: "-1px", // Adjusts horizontal position (nudge left)
            top: "4px", // Adjusts vertical position (nudge down)
          }}
        />{" "}
        Get Connection Code
      </Code>
      ...{" "}
    </p>

    <p> Then copy the code to your clipboard... </p>
    <SimpleImage
      h={400}
      src="docs_images/receive-only-nwc-connection-copy-code.png"
    />

    <p> Then paste this code into the app or website of your choice. </p>
    <p>The code will look like this: </p>
    <code
      style={{
        wordWrap: "break-word", // Ensures the word wraps to the next line
        wordBreak: "break-word", // Breaks the word if it overflows
        whiteSpace: "normal", // Allows text wrapping
      }}
    >
      nostr+walletconnect://p&9XTp@dGjsUE5BwMK2ybUlowXQ53F*P@b7V8QvX!H9W*#qjyPQkhEyPFqcE^uK?relay=wss%3A%2F%2Frelay-nwc.rizful.com%2Fv1&secret=Fsu!ptAR&are4DKE9EYcqz^TP$zVf%o@vvuoY^$y2WuawQdmV47MVUk$y^WM@As&lud16=info@rizful.com
    </code>
  </TypographyStylesProvider>
);
